export const primaryColor = '#0059A8'
export const warningColor = '#FFBF00'
export const warningTextColor = '#9B6803'
export const warningBackgroundColor = '#fffbe6'
export const successColor = '#318500'
export const errorColor = '#e10008'
export const colorText = '#333'
export const secondaryTextColor = '#00000090' // Was 8a (54%), now 90 (56%)
export const backgroundColor = '#f5f5f5'
export const disabledColor = '#eee'
